export default __webpack_public_path__ + "static/media/no-image-mody.88c7c2f0.png";